/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li6Inputs */

const en_guide_what_is_json_s2_li6 = /** @type {(inputs: Guide_What_Is_Json_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Object</strong>: Collection of key-value pairs: <code>&#123;"key": "value"&#125;</code>`)
};

const ko_guide_what_is_json_s2_li6 = /** @type {(inputs: Guide_What_Is_Json_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Object</strong>: 키-값 쌍의 모음: <code>&#123;"key": "value"&#125;</code>`)
};

const ja_guide_what_is_json_s2_li6 = /** @type {(inputs: Guide_What_Is_Json_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>オブジェクト</strong>: キーと値のペアの集合：<code>&#123;"key": "value"&#125;</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Object</strong>: Collection of key-value pairs: <code>&#123;\"key\": \"value\"&#125;</code>" |
*
* @param {Guide_What_Is_Json_S2_Li6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li6 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li6(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li6(inputs)
	return ja_guide_what_is_json_s2_li6(inputs)
});